(function($){

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *       the user visible viewport of a web browser.
     *       only accounts for vertical position, not horizontal.
     */
    var $w = $(window);
    $.fn.visible = function(partial,hidden,direction){

        if (this.length < 1)
            return;

        var $t        = this.length > 1 ? this.eq(0) : this,
            t         = $t.get(0),
            vpWidth   = $w.width(),
            vpHeight  = $w.height(),
            direction = (direction) ? direction : 'both',
            clientSize = hidden === true ? t.offsetWidth * t.offsetHeight : true;

        if (typeof t.getBoundingClientRect === 'function'){

            // Use this native browser method, if available.
            var rec = t.getBoundingClientRect(),
                tViz = rec.top    >= 0 && rec.top    <  vpHeight,
                bViz = rec.bottom >  0 && rec.bottom <= vpHeight,
                lViz = rec.left   >= 0 && rec.left   <  vpWidth,
                rViz = rec.right  >  0 && rec.right  <= vpWidth,
                vVisible   = partial ? tViz || bViz : tViz && bViz,
                hVisible   = partial ? lViz || rViz : lViz && rViz;

            if(direction === 'both')
                return clientSize && vVisible && hVisible;
            else if(direction === 'vertical')
                return clientSize && vVisible;
            else if(direction === 'horizontal')
                return clientSize && hVisible;
        } else {

            var viewTop         = $w.scrollTop(),
                viewBottom      = viewTop + vpHeight,
                viewLeft        = $w.scrollLeft(),
                viewRight       = viewLeft + vpWidth,
                offset          = $t.offset(),
                _top            = offset.top,
                _bottom         = _top + $t.height(),
                _left           = offset.left,
                _right          = _left + $t.width(),
                compareTop      = partial === true ? _bottom : _top,
                compareBottom   = partial === true ? _top : _bottom,
                compareLeft     = partial === true ? _right : _left,
                compareRight    = partial === true ? _left : _right;

            if(direction === 'both')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)) && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
            else if(direction === 'vertical')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
            else if(direction === 'horizontal')
                return !!clientSize && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
        }
    };

})(jQuery);


/*!
 * jQuery imagesLoaded plugin v2.1.1
 * http://github.com/desandro/imagesloaded
 *
 * MIT License. by Paul Irish et al.
 */

/*jshint curly: true, eqeqeq: true, noempty: true, strict: true, undef: true, browser: true */
/*global jQuery: false */

;(function($, undefined) {
'use strict';

// blank image data-uri bypasses webkit log warning (thx doug jones)
var BLANK = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

$.fn.imagesLoaded = function( callback ) {
    var $this = this,
        deferred = $.isFunction($.Deferred) ? $.Deferred() : 0,
        hasNotify = $.isFunction(deferred.notify),
        $images = $this.find('img').add( $this.filter('img') ),
        loaded = [],
        proper = [],
        broken = [];

    // Register deferred callbacks
    if ($.isPlainObject(callback)) {
        $.each(callback, function (key, value) {
            if (key === 'callback') {
                callback = value;
            } else if (deferred) {
                deferred[key](value);
            }
        });
    }

    function doneLoading() {
        var $proper = $(proper),
            $broken = $(broken);

        if ( deferred ) {
            if ( broken.length ) {
                deferred.reject( $images, $proper, $broken );
            } else {
                deferred.resolve( $images );
            }
        }

        if ( $.isFunction( callback ) ) {
            callback.call( $this, $images, $proper, $broken );
        }
    }

    function imgLoadedHandler( event ) {
        imgLoaded( event.target, event.type === 'error' );
    }

    function imgLoaded( img, isBroken ) {
        // don't proceed if BLANK image, or image is already loaded
        if ( img.src === BLANK || $.inArray( img, loaded ) !== -1 ) {
            return;
        }

        // store element in loaded images array
        loaded.push( img );

        // keep track of broken and properly loaded images
        if ( isBroken ) {
            broken.push( img );
        } else {
            proper.push( img );
        }

        // cache image and its state for future calls
        $.data( img, 'imagesLoaded', { isBroken: isBroken, src: img.src } );

        // trigger deferred progress method if present
        if ( hasNotify ) {
            deferred.notifyWith( $(img), [ isBroken, $images, $(proper), $(broken) ] );
        }

        // call doneLoading and clean listeners if all images are loaded
        if ( $images.length === loaded.length ) {
            setTimeout( doneLoading );
            $images.unbind( '.imagesLoaded', imgLoadedHandler );
        }
    }

    // if no images, trigger immediately
    if ( !$images.length ) {
        doneLoading();
    } else {
        $images.bind( 'load.imagesLoaded error.imagesLoaded', imgLoadedHandler )
        .each( function( i, el ) {
            var src = el.src;

            // find out if this image has been already checked for status
            // if it was, and src has not changed, call imgLoaded on it
            var cached = $.data( el, 'imagesLoaded' );
            if ( cached && cached.src === src ) {
                imgLoaded( el, cached.isBroken );
                return;
            }

            // if complete is true and browser supports natural sizes, try
            // to check for image status manually
            if ( el.complete && el.naturalWidth !== undefined ) {
                imgLoaded( el, el.naturalWidth === 0 || el.naturalHeight === 0 );
                return;
            }

            // cached images don't fire load sometimes, so we reset src, but only when
            // dealing with IE, or image is complete (loaded) and failed manual check
            // webkit hack from http://groups.google.com/group/jquery-dev/browse_thread/thread/eee6ab7b2da50e1f
            if ( el.readyState || el.complete ) {
                el.src = BLANK;
                el.src = src;
            }
        });
    }

    return deferred ? deferred.promise( $this ) : $this;
};

})(jQuery);

(function( $ ){

  $.fn.fitVids = function( options ) {
    var settings = {
      customSelector: null
    }
    
    var div = document.createElement('div'),
        ref = document.getElementsByTagName('base')[0] || document.getElementsByTagName('script')[0];
        
    div.className = 'fit-vids-style';
    div.innerHTML = '&shy;<style>         \
      .fluid-width-video-wrapper {        \
         width: 100%;                     \
         position: relative;              \
         padding: 0;                      \
      }                                   \
                                          \
      .fluid-width-video-wrapper iframe,  \
      .fluid-width-video-wrapper object,  \
      .fluid-width-video-wrapper embed {  \
         position: absolute;              \
         top: 0;                          \
         left: 0;                         \
         width: 100%;                     \
         height: 100%;                    \
      }                                   \
    </style>';
                      
    ref.parentNode.insertBefore(div,ref);
    
    if ( options ) { 
      $.extend( settings, options );
    }
    
    return this.each(function(){
      var selectors = [
        "iframe", 
        "object", 
        "embed"
      ];
      
      if (settings.customSelector) {
        selectors.push(settings.customSelector);
      }
      
      var $allVideos = $(this).find(selectors.join(','));

      $allVideos.each(function(){
        var $this = $(this);
        if (this.tagName.toLowerCase() == 'embed' && $this.parent('object').length || $this.parent('.fluid-width-video-wrapper').length) { return; } 
        var height = this.tagName.toLowerCase() == 'object' ? $this.attr('height') : $this.height(),
            aspectRatio = height / $this.width();
        if(!$this.attr('id')){
            var videoID = 'fitvid' + Math.floor(Math.random()*999999);
            $this.attr('id', videoID);
        }
        $this.wrap('<div class="fluid-width-video-wrapper"></div>').parent('.fluid-width-video-wrapper').css('padding-top', (aspectRatio * 100)+"%");
        $this.removeAttr('height').removeAttr('width');
      });
    });
  
  }
})( jQuery );

/////////////////////////// Slideshow

( function( $ ) {
  $.gm_slideshow = $.gm_slideshow || {};

  $.fn.gmSlideshow = function(){
    this.each(function(){ 
      if ($(this).data('gm-slideshow')){
        return;
      }
      $(this).data('gm-slideshow', new GMSlideshow( $(this) ) ); 
    });

    return this;
  };

  $.fn.gmSlideSet = function(){
    return $(this).data('gm-slideshow').slideSet();
  }

  $.fn.gmCurrentSlide = function(){
    return $(this).data('gm-slideshow').currentSlide();
  }

  $.fn.gmNextSlide = function(){ 
    return $(this).data('gm-slideshow').nextSlide(); 
  };

  $.fn.gmPreviousSlide = function(){ 
    return $(this).data('gm-slideshow').previousSlide(); 
  };

  $.fn.gmShowSlide = function(i){ 
    return $(this).data('gm-slideshow').showSlide(i); 
  };

  $.fn.gmSlideshowSwipeHandler =  function (event, direction, distance) {  
    if(direction == 'left'){
      $(this).gmNextSlide();
    }
    if(direction == 'right'){
      $(this).gmPreviousSlide();
    }
  };

  $.fn.gmSlideshowSetupPositions = function(){ 
    return $(this).data('gm-slideshow').setupPositions(); 
  };

  
  function GMSlideshow(slideshow){
    if (slideshow.data('gm-slideshow-initialized')){
      return;
    }
    slideshow.data('gm-slideshow-initialized', true);
    var slides                = slideshow.find('.gm_slide');
    var n_slides              = slides.length;
    var images                = slideshow.find('img');
    var pagination_containers = slideshow.find('.' + slideshow.data('pagination-class'));
    var that                  = this;
    var current               = 0;
    var transition            = slideshow.data('transition');
    var move_positions, move_container;

    if (!transition){
      transition = 'inplace';
    }

    slideshow.data('current-slide', 0);
    slideshow.data('n-slides', n_slides);

    this.numberOfSlides = function (){
      return(n_slides);
    }

    this.showSlidePage = function (force){
      slideshow.gmShowSlide($(this).data('slide'), force);
    }

    this.slideSet = function(){
      return slides;
    }

    this.currentSlide = function(){
      return slides.eq(current);
    }

    this.showSlide = function (i, force){
      if (i == current && !force){
        return;
      }
      slides.removeClass('current');
      slides.eq(i).addClass('current');
      pagination_containers.find('.gm_pagination_slide_link').removeClass('current');
      pagination_containers.find('.gm_pagination_slide_link_' + i).addClass('current'); 
      slideshow.data('current-slide', i);
      if (transition == 'move_horizontal'){
        move_container.css({
          left: -move_positions[i]
        });
      }
      if (slideshow.data('change-handler')) Site[slideshow.data('change-handler')].call(slideshow);
      slideshow.trigger('gm:slideadvance');
      current = i;
    }

    this.previousSlide = function (force){
      var new_slide;
      if (slideshow.data('cycle')){
        new_slide = (current - 1 + n_slides) % n_slides;
      } else {
        new_slide = current - 1;
        if (new_slide < 0) new_slide = 0;
      }
      this.showSlide(new_slide, force);
    }

    this.nextSlide = function (force){
      var new_slide;
      if (slideshow.data('cycle')){
        new_slide = (current + 1) % n_slides;
      } else {
        new_slide = current + 1;
        if (new_slide >= n_slides) new_slide = n_slides - 1;
      }
      this.showSlide(new_slide, force);
    }

    this.setupPositions = function (){
      move_positions = [];
      if (transition == 'move_horizontal'){
        var x = 0;
        slides.each(function(i){
          var s = $(this);
          move_positions.push(x);
          s.css({
            left: x
          });
          x += s.outerWidth();
        });
      }
    }

    this.initSlideshow = function (){
      if (n_slides > 1){
        slides.each(function(i){
          var slide     = $(this);
          var page_link = $("<span>");
          page_link.addClass('gm_pagination_slide_link gm_pagination_slide_link_' + i);
          page_link.data('slide', i);
          if (slide.data('label')){
            page_link.html(slide.data('label'));
          } else {
            if (slideshow.data('index-label')){
              page_link.html(i + 1);
            }
          }
          pagination_containers.each(function(){
            $(this).append(page_link.clone(true));
          });
        });
        pagination_containers.find('.gm_pagination_slide_link').on('click touchend', this.showSlidePage);
      }
      this.setupPositions();
      this.showSlide(current, true);
    }

    if (transition == 'move_horizontal'){
      move_container  = slideshow.find('.gm_slideshow_move_container');
      var first       = slides.eq(0);
      var last        = slides.eq(slides.length - 1);
      $(window).on('resize', this.setupPositions);
    }

    if (images.length > 0){
      var closedThis = this;
      slideshow.imagesLoaded(function(){ closedThis.initSlideshow.call(closedThis); });
    } else {
      this.initSlideshow();
    }
  };
})( jQuery );
